import { Box } from '@mui/material';

type Tone =
  | 'primary'
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'neutral'
  | 'k01' | 'k02' | 'k03' | 'k04' | 'k05' | 'k06'
  | 'k07' | 'k08' | 'k09' | 'k10' | 'k11' | 'k12';

const TONES: Record<Tone, { bg: string; fg: string }> = {
  primary: { bg: 'var(--pm-primary-light)', fg: 'var(--pm-primary-dark)' },
  success: { bg: 'rgba(52,211,153,0.18)', fg: 'var(--pm-success)' },
  warning: { bg: 'rgba(251,191,36,0.18)', fg: 'var(--pm-warning)' },
  error: { bg: 'rgba(248,113,113,0.18)', fg: 'var(--pm-error)' },
  info: { bg: 'rgba(56,189,248,0.18)', fg: 'var(--pm-info)' },
  neutral: { bg: 'var(--pm-bg-muted)', fg: 'var(--pm-fg-muted)' },
  k01: { bg: 'rgba(129,199,132,0.18)', fg: 'var(--pm-k01)' },
  k02: { bg: 'rgba(100,181,246,0.18)', fg: 'var(--pm-k02)' },
  k03: { bg: 'rgba(206,147,216,0.18)', fg: 'var(--pm-k03)' },
  k04: { bg: 'rgba(255,171,145,0.18)', fg: 'var(--pm-k04)' },
  k05: { bg: 'rgba(77,208,225,0.18)', fg: 'var(--pm-k05)' },
  k06: { bg: 'rgba(244,143,177,0.18)', fg: 'var(--pm-k06)' },
  k07: { bg: 'rgba(174,213,129,0.18)', fg: 'var(--pm-k07)' },
  k08: { bg: 'rgba(179,157,219,0.18)', fg: 'var(--pm-k08)' },
  k09: { bg: 'rgba(239,154,154,0.18)', fg: 'var(--pm-k09)' },
  k10: { bg: 'rgba(77,182,172,0.18)', fg: 'var(--pm-k10)' },
  k11: { bg: 'rgba(255,204,128,0.18)', fg: 'var(--pm-k11)' },
  k12: { bg: 'rgba(176,190,197,0.18)', fg: 'var(--pm-k12)' },
};

interface PmPillProps {
  tone?: Tone;
  children: React.ReactNode;
}

/** PM-Pill — kompaktes Status/Label-Badge. */
export function PmPill({ tone = 'neutral', children }: PmPillProps) {
  const t = TONES[tone];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        background: t.bg,
        color: t.fg,
        fontSize: '0.72rem',
        fontWeight: 600,
        letterSpacing: '0.02em',
        padding: '2px 8px',
        borderRadius: '12px',
        lineHeight: 1.5,
        textTransform: 'uppercase',
      }}
    >
      {children}
    </Box>
  );
}
